/**
 * Axios Request Wrapper
 */

import logger from 'js-logger';
import axios from 'axios';
import get from 'lodash.get';
import { removeUserToken } from '../utils/auth.utils';

import {
  createBaseURL,
  createHeaders,
  getLogFormat,
  clearAuthorization,
  getClient,
  getCrossDomain,
  getLog,
  getDebug,
} from './auth.request.configurator';

/**
 * Request Wrapper with default success/error actions
 */
export default async (options) => {
  const debug = getDebug();
  try {
    if (logger) {
      logger.useDefaults();
      const log = getLog();
      if (log) logger.setHandler(log);
    }

    /**
     * Create an Axios Client with defaults if a client is already not passed
     */
    const client = getClient() ? getClient() : axios.create();

    /**
     * Http request interceptor.
     */
    const headers = createHeaders();

    const { userToken } = options;

    if (userToken) {
      headers.Authorization = `Bearer ${userToken}`;
    }
    if (getCrossDomain()) {
      client.defaults.crossDomain = true;
    }

    client.interceptors.request.use(
      config => Object.assign(config, {
        baseURL: createBaseURL(),
        headers,
      }),
      error => Promise.reject(error),
    );
    const response = await client(options);
    if (debug) {
      if (getLogFormat() === 'full') {
        logger.debug('Request Successful!', response);
      } else if (getLogFormat() === 'minimal') {
        logger.debug(
          (new Date()).toTimeString(),
          response.status,
          response.statusText,
          response.config.url,
        );
      }
    }
    return response.data;
  } catch (error) {
    logger.error('Request Failed:', error.config);
    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      if (error.response.invalid_session) {
        removeUserToken();
        clearAuthorization();
      }
      if (debug) {
        logger.error('Status:', error.response.status);
        logger.error('Data:', error.response.data);
        logger.error('Headers:', error.response.headers);
      }
    } else {
      // Something else happened while setting up the request
      // triggered the error
      logger.error(`Error Message: ${error.message}`);
      error.message = 'NetworkError';
    }
    throw new Error(get(error, 'response.data.message', get(error, 'message', get(error, 'response'))));
  }
};

// export { client };
